import styled from "styled-components";

export const DrawerHeadbar = styled.div`
  padding: 16px 24px;
`;

export default DrawerHeadbar;
